<ngx-json-ld [json]='{
    "@context": "http://schema.org",
    "@type": "WebPage",
    "name": "Gratis Demo",
    "description": "Maak gratis een demobruiloft aan om de app te proberen!"
}'></ngx-json-ld>

<div class="content-box content-box-responsive-single content-box-small" *ngIf="!eventNameExists && !eventCreated">
  <app-create-event (submitted)="eventNameSubmitted($event)"></app-create-event>
</div>

<div class="content-box content-box-responsive-single content-box-small" *ngIf="eventNameExists && !eventCreated">
  <app-signup [busy]="busy" (submitted)="accountDetailsSubmitted($event)" [error]="error"
              [eventName]="eventName"></app-signup>
</div>

<div class="content-box content-box-responsive-single content-box-small" *ngIf="eventNameExists && eventCreated">
  <fa-icon class="confirm-icon" [icon]="['far', 'envelope']"></fa-icon>
  <br/>
  <p class="text">Je account is aangemaakt! Je kunt nu <a routerLink="/login">inloggen</a> met je emailadres en wachtwoord.</p>
</div>
